import { render, staticRenderFns } from "./ActivationLesson.vue?vue&type=template&id=2ce2ba2c&scoped=true&"
import script from "./ActivationLesson.vue?vue&type=script&lang=js&"
export * from "./ActivationLesson.vue?vue&type=script&lang=js&"
import style0 from "./ActivationLesson.vue?vue&type=style&index=0&id=2ce2ba2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce2ba2c",
  null
  
)

export default component.exports